// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* center page content */
/* .App {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
} */

/* open button */
.open-btn {
  padding: 10px 20px;
}.modal h2{
  color: #004996;
}

/* overlay background */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(11, 11, 11, 0.382);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.category-modal{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}

/* modal box */
.modal {
  position: relative;
  background: rgb(255, 255, 255);
  padding: 20px 25px;
  border-radius: 8px;
  width: 880px;
  text-align: center;
  animation: fadeIn 0.3s ease;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
}

.edit-button {
  position: absolute;
 top: 5px;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  color: #121212;
  font-size: 20px;
}

.edit-button:hover {
  color: #a80202;
  rotate: 1.1deg;
  animation: bell-shake 0.8s linear;
}

/* Responsive adjustments for modal */
@media (max-width: 1024px) {
  .modal {
    width: 65vw;
    padding: 18px 20px;
  }
}



@media (max-width: 768px) {
  .modal {
    width: 65vw;
    padding: 15px;
  }
  
  .modal h2 {
  }
}

@media (max-width: 480px) {
  .modal {
    width: 80vw;
    padding: 12px;
    border-radius: 6px;
  }
  
  .compact-modal{
    width: 90vw;;
  }
  .modal h2 {
  }
}

/* Large modal for edit forms */
.modal:has(.modal-form) {
  width: 800px;
  max-width: 95vw;
  text-align: left;
}

/* Modal form specific styles */
.modal-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.modal-form .form-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #f9f9f9;
}

.modal-form .form-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-weight: 600;
  border-bottom: 1px solid #BA7953;
  padding-bottom: 5px;
}

.modal-form .form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
}

.modal-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1;
}

.modal-form .form-group label {
  font-weight: 500;
  color: #333;
}

.modal-form .form-group input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-form .form-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
}

.modal-form .form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: center;
}

.modal-form .profile-image-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.modal-form .current-image img {
  border-radius: 50%;
  border: 2px solid #ddd;
}

/* Responsive modal */
@media (max-width: 768px) {
  .modal:has(.modal-form) {
    width: 95vw;
    padding: 15px;
  }
  
  .modal-form .form-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .modal-form .profile-image-section {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* close button */
.close-btn {
  margin-top: 15px;
  padding: 8px 15px;
}

/* fade animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Image Modal Styles */
.modal-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 10px;
}

.modal-full-image {
  max-width: 100%;
  max-height: 60vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  width: 100%;
}

.delete-button {
  padding: 10px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.delete-button:hover {
  background-color: #c82333;
}

.modal:has(.modal-image-container) {
  width: 600px;
  max-width: 95vw;
}

.modal.admin-user-modal {
  width: min(720px, 94vw);
  max-width: 94vw;
}

@media (max-width: 768px) {
  .modal.admin-user-modal {
    width: 95vw;
    max-width: 95vw;
  }
}

@media (max-width: 768px) {
  .modal:has(.modal-image-container) {
    width: 95vw;
  }
  
  .modal-full-image {
    max-height: 50vh;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/modal.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;;;;;GAKG;;AAEH,gBAAgB;AAChB;EACE,kBAAkB;AACpB,CAAC;EACC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;CACnB,QAAQ;EACP,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;;;AAIA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;EACA;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;EACA;EACA;AACF;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF","sourcesContent":["/* center page content */\n/* .App {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n} */\n\n/* open button */\n.open-btn {\n  padding: 10px 20px;\n}.modal h2{\n  color: #004996;\n}\n\n/* overlay background */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(11, 11, 11, 0.382);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.category-modal{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n/* modal box */\n.modal {\n  position: relative;\n  background: rgb(255, 255, 255);\n  padding: 20px 25px;\n  border-radius: 8px;\n  width: 880px;\n  text-align: center;\n  animation: fadeIn 0.3s ease;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.edit-button {\n  position: absolute;\n top: 5px;\n  right: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #121212;\n  font-size: 20px;\n}\n\n.edit-button:hover {\n  color: #a80202;\n  rotate: 1.1deg;\n  animation: bell-shake 0.8s linear;\n}\n\n/* Responsive adjustments for modal */\n@media (max-width: 1024px) {\n  .modal {\n    width: 65vw;\n    padding: 18px 20px;\n  }\n}\n\n\n\n@media (max-width: 768px) {\n  .modal {\n    width: 65vw;\n    padding: 15px;\n  }\n  \n  .modal h2 {\n  }\n}\n\n@media (max-width: 480px) {\n  .modal {\n    width: 80vw;\n    padding: 12px;\n    border-radius: 6px;\n  }\n  \n  .compact-modal{\n    width: 90vw;;\n  }\n  .modal h2 {\n  }\n}\n\n/* Large modal for edit forms */\n.modal:has(.modal-form) {\n  width: 800px;\n  max-width: 95vw;\n  text-align: left;\n}\n\n/* Modal form specific styles */\n.modal-form {\n  max-height: 70vh;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n.modal-form .form-section {\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n}\n\n.modal-form .form-section h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-weight: 600;\n  border-bottom: 1px solid #BA7953;\n  padding-bottom: 5px;\n}\n\n.modal-form .form-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n.modal-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  flex: 1;\n}\n\n.modal-form .form-group label {\n  font-weight: 500;\n  color: #333;\n}\n\n.modal-form .form-group input {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.modal-form .form-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n}\n\n.modal-form .form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.modal-form .profile-image-section {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.modal-form .current-image img {\n  border-radius: 50%;\n  border: 2px solid #ddd;\n}\n\n/* Responsive modal */\n@media (max-width: 768px) {\n  .modal:has(.modal-form) {\n    width: 95vw;\n    padding: 15px;\n  }\n  \n  .modal-form .form-row {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .modal-form .profile-image-section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* close button */\n.close-btn {\n  margin-top: 15px;\n  padding: 8px 15px;\n}\n\n/* fade animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Image Modal Styles */\n.modal-image-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 10px;\n}\n\n.modal-full-image {\n  max-width: 100%;\n  max-height: 60vh;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  width: 100%;\n}\n\n.delete-button {\n  padding: 10px 20px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.delete-button:hover {\n  background-color: #c82333;\n}\n\n.modal:has(.modal-image-container) {\n  width: 600px;\n  max-width: 95vw;\n}\n\n.modal.admin-user-modal {\n  width: min(720px, 94vw);\n  max-width: 94vw;\n}\n\n@media (max-width: 768px) {\n  .modal.admin-user-modal {\n    width: 95vw;\n    max-width: 95vw;\n  }\n}\n\n@media (max-width: 768px) {\n  .modal:has(.modal-image-container) {\n    width: 95vw;\n  }\n  \n  .modal-full-image {\n    max-height: 50vh;\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n  }\n  \n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
